import { render, staticRenderFns } from "./ComponentMessage.vue?vue&type=template&id=8c67d940"
import script from "./ComponentMessage.vue?vue&type=script&lang=js"
export * from "./ComponentMessage.vue?vue&type=script&lang=js"
import style0 from "./ComponentMessage.vue?vue&type=style&index=0&id=8c67d940&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports